export default "__VITE_ASSET__bea5a14b__"